// removed by extract-text-webpack-plugin
module.exports = {"text-box":"TextBox__text-box__ocVz8","header":"TextBox__header__lvtVv","sub-header":"TextBox__sub-header__1kT-Y","content":"TextBox__content__1Id_8","link":"TextBox__link__7yE5y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TextBox/TextBox.scss
// module id = 368
// module chunks = 0